import React from 'react';

type Props = {
  c?: any;
};

const CustomBanner: React.FC<Props> = ({ children }) => {
  return (
    <div className="relative">
      <svg
        width="307"
        height="47"
        viewBox="0 0 307 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto"
      >
        <path
          d="M307.021 0H0.0214844L10.5713 22L0.0214844 47H307.021L296.472 22L307.021 0Z"
          fill="#FC6780"
        />
      </svg>
      <div
        className="absolute top-1/2 text-center w-full"
        style={{
          transform: 'translate(0, -50%)'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CustomBanner;
